import { useNavigate } from "react-router-dom";
import { useSupport } from "../../SupportContext";
import { SupportArticle } from "./SupportArticle";
import { useArticleNavigation } from "../../hooks/useArticleNavigation";
import { Article } from "../../support.types";

export type Props = {
  articleId: string | undefined;
  className?: string;
};

export function SupportArticleContainer({ articleId, className }: Props) {
  const navigate = useNavigate();

  const { articles } = useSupport();

  const { prev, next } = useArticleNavigation({
    articleId: articleId ?? null,
  });

  const article = articles.find((article) => article.id === articleId);

  if (!article) {
    return null;
  }

  const handleNavigationClick = (article: Article) => {
    navigate(`/support/${article.id}`);
  };

  return (
    <SupportArticle
      article={article}
      className={className}
      prev={prev}
      next={next}
      onNavigationClick={handleNavigationClick}
    />
  );
}

export default SupportArticleContainer;
